import { createFileRoute, redirect } from '@tanstack/react-router'
import { CaseEdit } from 'pages/cases/CaseEdit'
import { caseDetailsSearchParams } from 'routes/cases/-searchParams'

const RouteComponent = () => {
  const { siteId, caseId } = Route.useSearch()

  return <CaseEdit siteID={siteId} caseID={caseId} />
}

export const Route = createFileRoute('/cases/edit')({
  component: RouteComponent,
  validateSearch: caseDetailsSearchParams,
  beforeLoad: ({ search }) => {
    if (!search.caseId) {
      throw redirect({
        to: '/cases',
        search: { siteId: search.siteId },
      })
    }
  },
  staticData: {
    title: 'Edit Case',
    layout: {
      enableScrolling: false,
      enforceMaxWidth: false,
    },
  },
})
